/** MSAL 5 waits for the page at the redirect URI to post the auth response back from a hidden iframe or popup; this app IS that page, so a framed response is answered here and the app does not boot. */

/** Pure, exported for authBridge.test.ts. A main-frame redirect is finished by `handleRedirectPromise()` instead, and a Teams tab frame carries no auth response. */
export function isFramedAuthResponse(location: { hash: string; search: string }, framed: boolean): boolean {
  if (!framed) return false
  return [location.hash.replace(/^#/, ''), location.search.replace(/^\?/, '')].some((part) => {
    const params = new URLSearchParams(part)
    return params.has('state') && (params.has('code') || params.has('error'))
  })
}

/** True when this window is a sign-in frame and its response has been handed to the main frame. */
export async function answerFramedAuthResponse(win: Window = window): Promise<boolean> {
  const framed = win.parent !== win || (Boolean(win.opener) && win.opener !== win)
  if (!isFramedAuthResponse(win.location, framed)) return false
  const { broadcastResponseToMainFrame } = await import('@azure/msal-browser/redirect-bridge')
  try {
    await broadcastResponseToMainFrame()
  } catch (error) {
    console.error('[msal] could not hand the sign-in response to the main window', error)
  }
  return true
}
